
import { Box, Button, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import * as api from '../services/api'
import Loader from 'components/Loader';
import add from '../../assets/icons/e-learning/add_back.svg'
import del from '../../assets/icons/e-learning/delete_red.svg'
import styles from './promote.module.css'
import icon_delete from '../../assets/icons/delete.svg'

function AddProjectPromote() {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const imgRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const [optionCheckList, setOptionCheckList] = useState([])
    const [optionHealthcheck, setOptionHealthcheck] = useState([])

    const [optionAll, setOptionAll] = useState([])

    const [menuSelected, setMenuSelected] = useState([[]]);

    const [data, setData] = useState({
        project_name: '',
        project_image: null,
        project_detail: '',
    })

    const [monitor, setMonitor] = useState([{
        checklist_group_code: '',
        field: '',
    }])

    useEffect(() => {
        checklist()
    }, [])

    const checklist = async () => {
        setLoading(true)
        let res = await api.checklist()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setOptionAll(data)
                // console.log(data)

                let list = []
                for (let i = 0; i < data.length; i++) {
                    if (data[i]) {
                        list.push({
                            key: data[i]['checklist_group_code'],
                            name: data[i]['checklist_group_name']
                        })
                    }
                    const unique = [...new Map(list.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    setOptionCheckList(unique)
                }
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value })
    }

    const handleButtonClick = () => {
        imgRef.current.click();
    }
    const handleFileChange = async (event) => {
        // const file = event.target.files && event.target.files[0];

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('project', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         // console.log(res['data']['data']['url'])
        //         setSelectedFile(res['data']['data']['url'])
        //         setData({ ...data, 'project_image': res['data']['data']['url'] })
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/project`)
        formData.append('file_source', 'project')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('project', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            setSelectedFile(res['data']['file_api_url'])
            setData({ ...data, 'project_image': res['data']['file_api_url'] })
        } else if (code === 403) {
            alert('รูปประกอบงานสร้างเสริม รองรับไฟล์เฉพาะ .jpeg, .jpg, .png เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    const handleClickSave = () => {
        if (!data['project_name']) {
            return alert('กรุณากรอกชื่อโครงการ')
        }
        if (data['project_image'] === null) {
            return alert('กรุณาเลือกรูปภาพประกอบ')
        }
        if (!data['project_detail']) {
            return alert('กรุณากรอกรายละเอียด')
        }
        saveNewProject()
    }

    const handClickAddMonitor = () => {
        monitor.push({
            checklist_group_code: '',
            field: '',
        })
        setMonitor([...monitor])

        menuSelected.push([])
        setMenuSelected([...menuSelected])
    }
    const handClickDeleteMonitor = (index, i) => {
        monitor.splice(index, 1)
        setMonitor([...monitor])

        menuSelected.splice(index, 1)
        setMenuSelected([...menuSelected])
    }

    const handleChangeMonitor = (e, idx, name) => {
        let newMonitor = [...monitor];
        newMonitor[idx][name] = e.target.value;
        setMonitor(newMonitor);

        if (name === 'checklist_group_code') {
            let newMonitor = [...monitor];
            newMonitor[idx]['field'] = '';
            setMonitor(newMonitor);

            let selected = optionAll.find(item => item.checklist_group_code === e.target.value);
            // console.log(selected['checklist'])
            let newMenuSelect = [...menuSelected]
            newMenuSelect[idx] = (selected['checklist'])
            setMenuSelected(newMenuSelect)
        }
    }

    const saveNewProject = () => {
        let list = {
            "project_name": data['project_name'],
            "project_image": data['project_image'],
            "project_detail": data['project_detail'],
            "project_target": monitor
        }
        // console.log(list)
        project(list)
    }

    const project = async (data) => {
        setLoading(true)
        let res = await api.addProject(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                alert('เพิ่มโครงการสำเร็จ')
                navigate('/managePromote')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/managePromote') }}
                    >กลับไป จัดการงานสร้างเสริมสุขภาพ</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>เพิ่มโครงการ</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '10px'
                }}>
                    <Box>
                        <Box sx={{ fontWeight: 500 }}>ชื่อโครงการ</Box>
                        <TextField
                            size='small'
                            fullWidth
                            placeholder='ชื่อโครงการ'
                            name='project_name'
                            value={data['project_name']}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>
                            รูปภาพประกอบ
                            <img
                                style={{ width: '25px', cursor: 'pointer' }}
                                src={add}
                                onClick={handleButtonClick}
                            />
                        </Box>

                        <Box sx={{
                            border: '1px solid #C7C7C7',
                            borderRadius: '5px',
                            padding: '10px',
                            height: '300px'
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'auto', height: '100%' }}>
                                <input
                                    type="file"
                                    ref={imgRef}
                                    style={{ display: "none" }}
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => {
                                        handleFileChange(e)
                                    }}
                                />
                                <img className={styles.illustration} src={data['project_image']} />
                                {data['project_image'] ?
                                    <Box sx={{
                                        display: 'flex',
                                        "@media (max-width: 500px)": {
                                            justifyContent: 'end'
                                        }
                                    }} >
                                        <Box>
                                            <img
                                                src={icon_delete}
                                                style={{ position: 'static', cursor: 'pointer' }}
                                                onClick={() => { setData({ ...data, 'project_image': null }) }}
                                            />
                                        </Box>
                                    </Box>
                                    : null
                                }
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ fontWeight: 500 }}>รายละเอียด</Box>
                        <TextField
                            size='small'
                            fullWidth
                            multiline
                            rows={4}
                            placeholder='อธิบายที่นี่...'
                            name='project_detail'
                            value={data['project_detail']}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ fontWeight: 500 }}>เลือกค่าที่ต้องการ Monitor ในโครงการนี้</Box>
                            <img
                                style={{ width: '25px', cursor: 'pointer' }}
                                src={add}
                                onClick={() => { handClickAddMonitor() }}
                            />
                        </Box>

                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '5fr 5fr 1fr',
                            gridGap: '10px'
                        }}>
                            <Box>ชื่อกลุ่มตรวจที่ต้องการ</Box>
                            <Box>ชื่อค่าที่ต้องการ</Box>
                            <Box></Box>
                        </Box>

                        {monitor.map((item, index) => (
                            <React.Fragment key={index}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '5fr 5fr 1fr',
                                    gridGap: '10px'
                                }}>
                                    <Select
                                        fullWidth
                                        size='small'
                                        value={item['checklist_group_code'] || 'null'}
                                        onChange={(e) => {
                                            handleChangeMonitor(e, index, 'checklist_group_code')
                                        }}
                                    >
                                        <MenuItem value='null'>เลือกกลุ่มตรวจที่ต้องการ</MenuItem>
                                        {optionCheckList.map((i, idx) => (
                                            <MenuItem key={idx} value={i['key']}>{i['name']}</MenuItem>
                                        ))}
                                    </Select>
                                    <Select
                                        fullWidth
                                        size='small'
                                        value={item['field'] || 'null'}
                                        onChange={(e) => {
                                            handleChangeMonitor(e, index, 'field')
                                        }}
                                    >
                                        <MenuItem value='null'>เลือกค่าที่ต้องการ</MenuItem>
                                        {menuSelected[index].map((i, idx) => (
                                            <MenuItem key={idx} value={i['field']}>{i['field_name']}</MenuItem>
                                        ))}

                                        {/* {optionHealthcheck.map((i, idx) => (
                                            <MenuItem key={idx} value={i['field']}>{i['field_name']}</MenuItem>
                                        ))} */}
                                    </Select>

                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <img
                                            style={{ cursor: 'pointer', width: '25px' }}
                                            src={del}
                                            onClick={() => { handClickDeleteMonitor(index) }}
                                        />
                                    </Box>
                                </Box>
                            </React.Fragment>
                        ))}

                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant='contained' onClick={() => { handleClickSave() }} >บันทึก</Button>
                </Box>

            </Box>
        </>
    )
}

export default AddProjectPromote
